import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';

import { Tracking } from 'bdvp-tracking';
import { useBasePath } from 'bdvp-common/src/hooks/config';

/** Styled/Wrapper components */
const Wrapper = styled.div`
    padding: 0 15px 41px 15px;

    ${media.mdmin`
        padding: 15px 32px 25px 14px;
    `}
`;

const List = styled.ul`
    column-count: 1;
    ${media.mdmin`
        column-count: 2;
    `}
`;

const ListItem = styled.li`
    margin-bottom: 5px;
    color: ${COLORS.linkBlueOnDark};
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;

    a {
        border-radius: 5px;
        color: #e6e6e6;
        display: inline-block;
        padding: 10px 0;
        &:hover {
            color: #e6e6e6;
        }
        ${media.mdmin`
            padding: 10px;
            &:hover {
                background-color: ${COLORS.mlbGrey6};
            }
        `}
    }
`;

/** Component */
const Content = ({
    subnav,
    onClick,
}) => {

    const basePath = useBasePath();
    const history = useHistory();

    const handleClick = useCallback((event, index, topic) => {

        event.preventDefault();
        Tracking.trackMenuItemClick(event, index);
        onClick();
        history.push(topic.link || '/');

    }, [history]);

    return (
        <Wrapper>
            <List>
                {
                    subnav && subnav.map((topic = {}, index) => {

                        const topicText = topic.text;
                        const topicLink = (
                            <a
                                onClick={(event) => {

                                    handleClick(event, index, topic);

                                }}
                                aria-label={topicText}
                                href={`${basePath}${topic.link || '/'}`}
                            >
                                {topicText}
                            </a>
                        );

                        return (
                            <ListItem key={index}>
                                {topicLink}
                            </ListItem>
                        );

                    })
                }
            </List>
        </Wrapper>
    );

};

Content.propTypes = {
    subnav: PropTypes.array,
    onClick: PropTypes.func,
};

Content.defaultProps = {
    subnav: [],
    onClick: () => {},
};

export default Content;
